import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "recently-visited-products__header" }
const _hoisted_2 = { class: "recently-visited-products__header-title" }

import { computed } from 'vue';

import useLastVisitedProducts from '@/composables/useRecentlyVisitedProducts';
import useWebsiteTexts from '@/composables/useWebsiteTexts';

import ProductsCarouselV2 from '@/components/ProductsCarousel/ProductsCarouselV2.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecentlyVisitedProducts',
  props: {
  block: {
    type: Object,
  },
},
  setup(__props) {

const props = __props



const { websiteText } = useWebsiteTexts();
const { products } = useLastVisitedProducts();

const marginTop = computed(() => props.block?.fields.MarginTop || '0px');
const marginBottom = computed(() => props.block?.fields.MarginBottom || '0px');
const title = computed(
  () =>
    props.block?.fields.Title ||
    websiteText('recently_visited_products_block__title').value
);

return (_ctx: any,_cache: any) => {
  return (_unref(products).length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "recently-visited-products",
        style: _normalizeStyle({ marginTop: _unref(marginTop), marginBottom: _unref(marginBottom) })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(title)), 1)
        ]),
        _createVNode(ProductsCarouselV2, { products: _unref(products) }, null, 8, ["products"])
      ], 4))
    : _createCommentVNode("", true)
}
}

})